import { Recognition, RecognitionModel } from 'models/recognition.model';
import { DraftRecognitionValidationField } from './recognition.type';

export const TASK_TITLE_CHARACTER_LIMIT = 100;
export const TASK_DESCRIPTION_CHARACTER_LIMIT = 900;

export const validateTitle = (
  title: string,
  fullValidation = false,
): string => {
  if (fullValidation && !title.length) {
    return 'Title is required';
  }

  if (title.length > TASK_TITLE_CHARACTER_LIMIT) {
    return `Title must be less than ${TASK_TITLE_CHARACTER_LIMIT} characters long. You are ${
      title.length - TASK_TITLE_CHARACTER_LIMIT
    } characters over`;
  }

  return '';
};

export const validateDescription = (
  description: string,
  fullValidation = false,
): string => {
  if (fullValidation && !description.length) {
    return 'Description is required';
  }

  if (description.length > TASK_DESCRIPTION_CHARACTER_LIMIT) {
    return `Description must be less than ${TASK_DESCRIPTION_CHARACTER_LIMIT} characters long. You are ${
      description.length - TASK_DESCRIPTION_CHARACTER_LIMIT
    } characters over`;
  }

  return '';
};

export const validateAmountCompletedTask = (
  amount: number,
  fullValidation = false,
  type: RecognitionModel,
  taskIds: string[] = [],
): string => {
  if (type === 'BY_TASK' && taskIds.length === 0) {
    return 'You should choose at least one task';
  }

  if (type === 'BY_COUNT' && fullValidation && !amount) {
    return 'Number of completed tasks is required';
  }

  return '';
};

export const validateRecognition = (
  recognition: Recognition,
  fullValidation = true,
): DraftRecognitionValidationField => {
  const { title, description, completedTasks, type, taskIds } = recognition;

  return {
    title: validateTitle(title, fullValidation),
    description: validateDescription(description, fullValidation),
    completedTasks: validateAmountCompletedTask(
      +completedTasks,
      fullValidation,
      type,
      taskIds,
    ),
  };
};
